import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { resources } from './resources';

export const appLanguageStorageKey = 'waf-crm-locale';
export const defaultLanguage = 'uk';
export const supportedLanguages = ['uk', 'en'] as const;

const storedLanguage =
  typeof window === 'undefined'
    ? null
    : window.localStorage.getItem(appLanguageStorageKey);

const initialLanguage =
  storedLanguage && supportedLanguages.includes(storedLanguage as 'uk' | 'en')
    ? storedLanguage
    : defaultLanguage;

if (!i18n.isInitialized) {
  void i18n.use(initReactI18next).init({
    resources,
    lng: initialLanguage,
    fallbackLng: defaultLanguage,
    interpolation: {
      escapeValue: true,
    },
  });
}

i18n.on('languageChanged', (language) => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(appLanguageStorageKey, language);
  }
});

export default i18n;
export { i18n };
